const StreetAddress = ({
  street = '',
  state = '',
  city = '',
  zip = '',
  unit = '',
  country = '',
  show = '',
  hasUnitLabel = '',
}: {
  street?: string;
  state?: string;
  city?: string;
  zip?: string;
  unit?: string;
  country?: string;
  show?: string | boolean;
  hasUnitLabel?: string | boolean;
} = {}) => ({
  street: String(street),
  state: String(state),
  city: String(city),
  zip: String(zip),
  unit: String(unit),
  country: String(country),
  show: Boolean(show),
  hasUnitLabel: Boolean(hasUnitLabel),
});

export default StreetAddress;

export type StreetAddressProps = Partial<ReturnType<typeof StreetAddress>>;
